import AbstractChannel from './AbstractChannel'

export default class ParkFast extends AbstractChannel {

  name = 'parkfast'
  title = 'ParkFast'
  titleShort = 'ParkFast'
  color = '#D62728'

  supportedFeatures = ['blackouts']

}
